import type { CampaignTemplate } from '@/data'
import api from '../..'

export async function getTemplate(
  campaignId: string,
  templateId: string,
): Promise<CampaignTemplate | null> {
  const res = await api.get(`/campaigns/${campaignId}/templates/${templateId}`)
  return res.data.data
}
